import React from "react";

const LoadingForm = ({ t_type }) => {
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-loading">
            <div className="tutorial-element">
              {t_type === "reg-mem" && (
                <div className="top-close">
                  <button
                    className="btn-close"
                    onClick={() => {
                      window.handleConfirm();
                    }}
                  >
                    <i className="icon i-top-close">닫기</i>
                  </button>
                </div>
              )}
              <div className="ai-motion is-motion">
                <span className="i-motion i-motion-loading"></span>
              </div>
              <div className="ai-writer">
                <div className="dp-table">
                  <div className="dp-cell">
                    <div className="ai-txt-1">
                      AI스캐닝 결과 리포트를 생성 중입니다.
                    </div>
                    <div className="type-it type-it-1">
                      학생의 프로필 정보를 분석 중입니다···
                    </div>
                    <div className="type-it type-it-2">
                      AI스캐닝에 필요한 정보를 최적화 하는 중입니다···
                    </div>
                    <div className="type-it type-it-3">
                      전체 지식맵을 토대로 단원 이해도를 측정 중입니다···
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingForm;
